import React, { FC } from 'react';
import styled from 'styled-components';
import { Quantity } from '../../../components/quantity/quantity';
import { TD } from '../../../components/table/table';
import {
  toDisplayDate,
  toDisplayDateAndTime,
  toDisplayTime,
} from '../../../constants/dates';
import { IVMIOrder } from '../../../graphql/types';
import { Medium } from '../../../styles/fonts';
import { StyledRowTop } from '../order-summary-card';

const StyledText = styled.div`
  font-family: ${Medium};
`;

const StyledRow = styled.div`
  padding-right: 1rem;
`;

export const PtOrderDetailsTableBody: FC<{ order: IVMIOrder }> = ({
  order,
}) => {
  return (
    <tbody>
      {order.items &&
        order.items.map((item, index) => {
          return (
            <tr key={index} data-type="item" data-value={item.index}>
              <TD data-type="eta">
                <StyledRow>{toDisplayDate(item.deliveryEta)}</StyledRow>
                <StyledRow>{toDisplayTime(item.deliveryEta)}</StyledRow>
              </TD>
              <TD data-type="tank">{item.tankId}</TD>
              <TD>
                <StyledText
                  data-type="product-name"
                  title={
                    'The Product name in VMI differs from the GSAP product name'
                  }
                >
                  {item.productName}
                </StyledText>
              </TD>
              <TD data-type="product-code">{item.productCode}</TD>
              <TD data-type="potential-volume">
                <Quantity quantity={item.deliveryVolume} unitOfMeasure={'L'} />
              </TD>
            </tr>
          );
        })}
    </tbody>
  );
};
